// Accessibility: keyboard support for custom controls and overlay dismissal.
(function () {
  var DRAWERS = [
    { selector: '.js-cartDrawer', toggle: '.js-cartToggle' },
    { selector: '.js-nav', toggle: '.js-navToggle' },
    { selector: '.js-searchDrawer', toggle: '.js-searchDrawerToggle' }
  ];

  function focusOptionSelectorChoice(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel || panel.getAttribute('aria-hidden') === 'true') return;

    var choice = panel.querySelector('.js-optionSelectorOption[aria-pressed="true"]') ||
      panel.querySelector('.js-optionSelectorOption:not([disabled])');
    if (choice) choice.focus();
  }

  document.addEventListener('keydown', function (event) {
    var optionSelectorToggle = event.target.closest('.js-optionSelectorToggle');
    if (optionSelectorToggle && (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')) {
      // Open through the existing click handler, then enter the revealed list.
      event.preventDefault();
      optionSelectorToggle.click();
      window.setTimeout(function () {
        focusOptionSelectorChoice(optionSelectorToggle);
      });
      return;
    }

    // Enter/Space activates custom role="button" controls (swatch pickers,
    // cart-upsell carousel, swiper arrows) the same way a native button would.
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      var target = event.target.closest('[role="button"]');
      var nativelyActivatable = ['BUTTON', 'A', 'INPUT', 'SELECT', 'TEXTAREA'];
      if (target && nativelyActivatable.indexOf(target.tagName) === -1) {
        event.preventDefault();
        target.click();
      }
      return;
    }

    // Escape closes whichever modal/drawer is currently open.
    if (event.key === 'Escape' || event.key === 'Esc') {
      var openModal = document.querySelector('.modal[aria-hidden="false"]');
      if (openModal) {
        var closeButton = openModal.querySelector('.js-modalClose');
        if (closeButton) closeButton.click();
        return;
      }

      for (var i = 0; i < DRAWERS.length; i++) {
        var openDrawer = document.querySelector(DRAWERS[i].selector + ':not([aria-hidden="true"])');
        if (openDrawer) {
          var toggleButton = document.querySelector(DRAWERS[i].toggle);
          if (toggleButton) toggleButton.click();
          return;
        }
      }
    }
  });
})();
